import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import ClickOutside from 'react-click-outside';

import Quote from 'models/quote';
import { Location } from 'models/locations';

import DatePicker from 'components/common/date-picker';
import CalendarIcon from 'components/svgs/calendar-icon';
import MonthlyPhoneNumber from 'components/checkout/parking-details/monthly-phone-number';

const propTypes = {
  showCalendar: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  msa: PropTypes.string.isRequired,
  quote: PropTypes.instanceOf(Quote),
  selectedLocation: PropTypes.instanceOf(Location).isRequired,
  monthlyStart: PropTypes.instanceOf(moment),
  hideCalendar: PropTypes.func.isRequired,
  toggleCalendar: PropTypes.func.isRequired,
  handleMonthlyStartChange: PropTypes.func.isRequired,
};

const defaultProps = {
  quote: new Quote(),
  monthlyStart: moment(),
  showCalendar: false,
};

const MonthlyParkingStartDate = ({
  quote,
  selectedLocation,
  monthlyStart,
  hideCalendar,
  handleMonthlyStartChange,
  locale,
  showCalendar,
  toggleCalendar,
  msa,
}) => {
  if (!quote.isMonthly) { return null; }

  const date = moment(monthlyStart);

  let calendar;
  if (showCalendar) {
    calendar = (
      <div className="date-time-selector container row position-absolute text-color-dark-slate heavy-shadowed date-only">
        <div className="row background-color-white">
          <div className="col-xs-8 col-gutter-right-0">
            <div className="border-style-solid border-side-right border-color-light-grey">
              <ClickOutside onClickOutside={hideCalendar} >
                <DatePicker
                  minDate={moment().startOf('day')}
                  date={date.clone().startOf('day')}
                  onDateChange={handleMonthlyStartChange}
                  locale={locale}
                />
              </ClickOutside>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="noselect monthly clean-calendar background-color-white minimal-monthly">
      <div className="checkout-section monthly-date-panel clearfix position-relative">
        <div className="text-color-dark-slate text-size-20 text-weight-bold padding-top-xs-20 padding-top-sm-0">Monthly Parking Start Date</div>
        <div className="margin-top-20 padding-bottom-30 clickable" onClick={toggleCalendar}>
          <div className="width-200 display-inline-block background-color-lighter-grey display-inline-block padding-left-10 padding-vertical-5 text-size-18 text-weight-book text-color-dark-slate">
            <div>{date.format('ddd, MMM D')}</div>
          </div>
          <div className="display-inline-block calendar-icon margin-left-10 margin-top-5 vertical-align-top">
            <CalendarIcon />
          </div>
        </div>
        {calendar}
        <MonthlyPhoneNumber msa={msa} selectedLocation={selectedLocation} />
      </div>
    </div>
  );
};

MonthlyParkingStartDate.propTypes = propTypes;
MonthlyParkingStartDate.defaultProps = defaultProps;
export default MonthlyParkingStartDate;
